import { render } from "./PendingPaymentsPage.vue?vue&type=template&id=00013a9d&scoped=true"
import script from "./PendingPaymentsPage.vue?vue&type=script&lang=js"
export * from "./PendingPaymentsPage.vue?vue&type=script&lang=js"

import "./PendingPaymentsPage.vue?vue&type=style&index=0&id=00013a9d&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00013a9d"]])

export default __exports__